export default "__VITE_ASSET__CvnLiKu5__"